var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caseItem public"},[_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":require("../../assets/images/case/caseImg8.jpg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"itemName"},[_vm._v("聊城市河道管理处")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78136e6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/ProjectCase3.vue
// module id = xnkA
// module chunks = 0